import React from "react";
import { observer } from "mobx-react-lite";
import { Box, IconButton } from "@mui/material";

import { CloseIcon } from "../../icons";
import Column from "../../ui/core/Column";
import WelcomeSection from "../../ui/home/WelcomeSection";

interface ClaimsChatPanelProps {
  onClose: () => void;
}

const ClaimWelcomeContent: React.FC<ClaimsChatPanelProps> = observer(
  ({ onClose }) => {
    return (
      <>
        <Box
          sx={{
            width: "100%",
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box flex="1" />

          <IconButton onClick={onClose} size="small">
            <CloseIcon size={18} />
          </IconButton>
        </Box>

        <Box sx={{ width: "100%", flex: 1, overflow: "auto", minHeight: 0 }}>
          <Column sx={{ justifyContent: "center", alignItems: "center" }}>
            <WelcomeSection subtitle="Ask questions about this claim" />
          </Column>
        </Box>
      </>
    );
  },
);

export default ClaimWelcomeContent;
